import React from 'react';
import { useSelector } from 'react-redux';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import {
  selectStaleBuildOpen,
  selectStaleBuildServerVersion,
} from '../store/slices/buildRefreshSlice';

function refreshWithCacheBust(serverBuildVersion) {
  const { pathname, search, hash } = window.location;
  const params = new URLSearchParams(search);
  params.set('b', serverBuildVersion || '1');
  window.location.href = `${pathname}?${params.toString()}${hash}`;
}

/**
 * Blocking dialog when the SPA build no longer matches the API (see api.js response interceptor).
 */
export default function StaleBuildDialog() {
  const open = useSelector(selectStaleBuildOpen);
  const serverBuildVersion = useSelector(selectStaleBuildServerVersion);

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      onClose={() => {}}
      aria-labelledby="stale-build-dialog-title"
    >
      <DialogTitle id="stale-build-dialog-title">Update required</DialogTitle>
      <DialogContent>
        <DialogContentText component="div">
          A new version of the app is available. This page no longer matches the server build.
          Refresh to load the latest version.
          {serverBuildVersion ? (
            <>
              <br />
              <br />
              Server build: {serverBuildVersion}
            </>
          ) : null}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => refreshWithCacheBust(serverBuildVersion)}
          autoFocus
        >
          Refresh
        </Button>
      </DialogActions>
    </Dialog>
  );
}
